import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Note from 'src/assets/images/Note.svg';
import NoteDark from 'src/assets/images/NoteDark.svg';
import {
    VerticalDetailViewBottomLeft,
    VerticalDetailViewBottomRight,
    AccountNameStyledDiv,
    PhysicianNameStyledDiv,
    StyledDiv,
    IconsContainer,
    IconPlaceHolder,
    CountContainer,
    Icon,
    LabelCount,
} from './ReportUsageHeader.styled';
import { StyledSpan } from 'src/pages/reportUsage/header/ReportUsageHeader.styled';
import { isMobileView, logErrorToConsole } from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import { VISIBLE } from 'src/constants/appConstants';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { isNotesVisited } from 'src/pages/scheduleSurgery/redux/actions';

const ReportUsageSubHeader = ({
    usageDetails,
    openUNIDLinks,
    selectedPhysicianData,
    isReportPayment,
    setViewSurgeryNotes,
    viewSurgeryNotes,
    noteCount,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );
    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));

    const storedPatientDetails = useSelector(
        (state) => state.reportUsageRootReducer.patientDetails
    );
    const {
        patientIdVisibility,
        patientInformationVisibility,
        reportUsagePatientDetails,
    } = useSelector((state) => state.loginReducer);
    const countryCode = localStorage.getItem('countryISOCode');

    // const noteCount = useSelector((state) => {
    //     return state.HeaderNotesReducer.reportUsageNotes.length;
    // });

    return (
        <>
            {!viewSurgeryNotes && (
                <VerticalDetailViewBottomLeft
                    id="reportUsage-subHeader-pii"
                    paddingLeft={
                        usageOrderSubmission?.clickedBtn === 'submit' && '13px'
                    }
                    // marginRight={
                    //     usageDetails.unidId ||
                    //     usageDetails.hrefId ||
                    //     storedPatientDetails?.hrefId
                    //         ? 'auto'
                    //         : 'unset'
                    // }
                    marginLeft={'20px'}
                    // lgMarginLeft={usageDetails.hrefId}
                    marginRight={
                        window.innerWidth >= sizes.largeDevice ? '10px' : '0'
                    }
                    mdMarginRight={isReportPayment && '20px'}
                    flexRatio={
                        window.innerWidth > sizes.mobileDevice &&
                        window.innerWidth <= sizes.smalDevice
                            ? 'none'
                            : 1.5
                    }
                    smMargin={'0px'}
                    smFlex={'1'}
                    smAlignItems = {'flex-start'}
                    mbMarginBottom={!isReportPayment && '-13px'}
                >
                    <AccountNameStyledDiv>
                        {usageDetails?.accountName
                            ? usageDetails?.accountName.replace(
                                  usageDetails?.accountId,
                                  ''
                              )
                            : ''}
                        <StyledSpan
                            padding={'0 4px 0 0'}
                            fontFamily={'AvenirNextWorld Italic'}
                            fontWeight={'initial'}
                            mbPadding={'0 4px 0 6px'}
                        >
                            {' '}
                            {usageDetails?.accountId &&
                                usageDetails?.accountId.replace(/^0+/, '')}
                        </StyledSpan>
                    </AccountNameStyledDiv>
                    <PhysicianNameStyledDiv>
                        {(usageDetails.physicianName ||
                            selectedPhysicianData?.physicianDisplayName) &&
                            !(
                                !selectedPhysicianData?.physicianDisplayName &&
                                usageDetails?.physicianId === 'Other Physician'
                            ) &&
                            `${t('common.drLabel')} ${
                                selectedPhysicianData?.physicianDisplayName
                                    ? selectedPhysicianData?.physicianDisplayName
                                    : usageDetails.physicianName
                            }`}
                        {(usageDetails.physicianName ||
                            selectedPhysicianData?.physicianDisplayName) &&
                            (usageDetails.patientFirstName ||
                                storedPatientDetails?.patientFirstName) &&
                            reportUsagePatientDetails?.includes(
                                'name'
                            ) &&
                            patientInformationVisibility === VISIBLE && (
                                <StyledSpan padding={'0 4px 0 4px'}>
                                    |
                                </StyledSpan>
                            )}
                        {patientInformationVisibility === VISIBLE &&
                            (usageDetails.patientFirstName ||
                                storedPatientDetails?.patientFirstName) &&
                            reportUsagePatientDetails?.includes(
                                'name'
                            ) && (
                                <StyledSpan
                                    color={'#140F4B'}
                                    fontFamily={'AvenirNextWorld Regular'}
                                >
                                    {`${t(
                                        'consignmentBilling.inventory.patient'
                                    )} ${
                                        storedPatientDetails?.patientFirstName
                                            ? storedPatientDetails?.patientFirstName
                                            : usageDetails.patientFirstName
                                    } ${
                                        storedPatientDetails?.patientLastName
                                            ? storedPatientDetails?.patientLastName
                                            : usageDetails.patientLastName
                                            ? usageDetails.patientLastName
                                            : ''
                                    }`}
                                </StyledSpan>
                            )}
                    </PhysicianNameStyledDiv>
                </VerticalDetailViewBottomLeft>
            )}

            {!viewSurgeryNotes && (
                <IconPlaceHolder>
                    {(usageDetails.unidId ||
                        usageDetails.hrefId ||
                        storedPatientDetails?.hrefId) &&
                        reportUsagePatientDetails?.includes(
                            'href'
                        ) && (
                            <VerticalDetailViewBottomRight
                                id="reportUsage-subHeader-hrefId-pii"
                                paddingLeft={
                                    usageOrderSubmission?.clickedBtn ===
                                        'submit' && '13px'
                                }
                                marginRight={isReportPayment && '50px'}
                               
                                LandscapeMarginRight={isReportPayment && '35px'}
                            >
                                {(storedPatientDetails?.hrefId ||
                                    usageDetails?.hrefId) &&
                                    patientIdVisibility === VISIBLE && (
                                        <h4
                                            style={{
                                                display: 'flex',
                                                fontSize: 12,
                                                color: '#4F4F4F',
                                                margin: 0,
                                                lineHeight: '21px',
                                                fontFamily:
                                                    'AvenirNextWorld Regular',
                                                whiteSpace: 'pre-wrap',
                                                width:
                                                    window.innerWidth ===
                                                        sizes.smalDevice &&
                                                    '100%',
                                                justifyContent:
                                                    window.innerWidth ===
                                                        sizes.smalDevice &&
                                                    'flex-end',
                                                     marginTop: '5px',
                                                marginBottom:
                                                    !usageDetails?.unidId &&
                                                    (usageDetails?.hrefId ||
                                                        storedPatientDetails?.hrefId)
                                                        ? isMobileView()
                                                            ? '0px'
                                                            : '25px'
                                                        : '0px',
                                            }}
                                        >
                                            {t('common.hrefLabel')}:{' '}
                                            <StyledDiv
                                                padding={'0 2px 0 3px'}
                                                mbFontFamily={
                                                    'AvenirNextWorld Regular'
                                                }
                                            >
                                                {storedPatientDetails?.hrefId
                                                    ? storedPatientDetails?.hrefId
                                                    : usageDetails?.hrefId}
                                            </StyledDiv>
                                        </h4>
                                    )}
                                {usageDetails.unidId && (
                                    <h4
                                        style={{
                                            fontSize: 12,
                                            color: '#4F4F4F',
                                            margin: 0,
                                            lineHeight: '21px',
                                            fontFamily:
                                                'AvenirNextWorld Regular',
                                        }}
                                    >
                                        {(usageDetails?.vendorCaseId?.startsWith(
                                            'UH_'
                                        ) ||
                                            usageDetails?.vendorCaseId?.startsWith(
                                                'AH_'
                                            )) &&
                                            t('common.unidLabel')}
                                        <span
                                            style={{
                                                color: '#1010EB',
                                                padding: '0 4px 0 2px',
                                                fontFamily:
                                                    'AvenirNextWorld Demi',
                                            }}
                                        >
                                            {usageDetails?.planStatus &&
                                            (usageDetails?.planStatus ===
                                                'Approved' ||
                                                usageDetails?.planStatus ===
                                                    'Plan Only' ||
                                                usageDetails?.isMtoStatus) ? (
                                                <span
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() =>
                                                        openUNIDLinks()
                                                    }
                                                >
                                                    {' '}
                                                    {usageDetails?.unidId}{' '}
                                                </span>
                                            ) : (
                                                usageDetails?.unidId
                                            )}
                                        </span>
                                        {' | '}
                                        <StyledSpan fontFamily={'AvenirNextWorld Regular'} padding={'0 2px 0 4px'}>
                                            {usageDetails?.planStatus &&
                                                (usageDetails?.isMtoStatus
                                                    ? usageDetails?.planStatus
                                                    : `${t(
                                                          'common.planText'
                                                      )} - ${
                                                          usageDetails?.planStatus
                                                      }`)}
                                        </StyledSpan>
                                    </h4>
                                )}
                            </VerticalDetailViewBottomRight>
                        )}
                </IconPlaceHolder>
            )}

            <IconsContainer>
                <>
                    {window.innerWidth > sizes.mediumDevice &&
                    !isUsagedSubmittedSuccessfully &&
                    !isSubmitClicked ? (
                        <IconPlaceHolder
                            id={`icon-placeholder-${usageDetails?.accountId || 'default'}`}
                            onClick={() => {
                                try {
                                setViewSurgeryNotes(true);
                                dispatch(isNotesVisited(true));
                                
                                // Scroll to top when notes open to ensure header is visible
                                setTimeout(() => {
                                    window.scrollTo(0, 0);
                                }, 150);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            <Icon
                            id="report-usage-header-icon"
                                deskPath={NoteDark}
                                mobilePath={Note}
                                bottom={'-4px'}
                            >
                                {noteCount > 0 && (
                                    <CountContainer
                                        colorNote={false}
                                        backgroundColor={'12c8f7'}
                                        desktopBorder={'2px solid #140F4B'}
                                        border={'2px solid #ffff'}
                                        width={
                                            noteCount > 0 && noteCount <= 9
                                                ? '18px'
                                                : noteCount >= 10 &&
                                                  noteCount <= 99
                                                ? '25px'
                                                : '27px'
                                        }
                                        height={
                                            noteCount > 0 && noteCount <= 9
                                                ? '18px'
                                                : noteCount >= 10 &&
                                                  noteCount <= 99
                                                ? '24px'
                                                : '27px'
                                        }
                                        right={
                                            noteCount > 0 && noteCount <= 9
                                                ? '7px'
                                                : noteCount >= 10 &&
                                                  noteCount <= 99
                                                ? '2px'
                                                : '2px'
                                        }
                                        top={
                                            noteCount > 0 && noteCount <= 9
                                                ? '-3px'
                                                : noteCount >= 10 &&
                                                  noteCount <= 99
                                                ? '-9px'
                                                : '-12px'
                                        }
                                        mbRight={
                                            noteCount > 0 && noteCount <= 9
                                                ? '7px'
                                                : '2px'
                                        }
                                        mbTop={
                                            noteCount > 0 && noteCount <= 9
                                                ? '-3px'
                                                : '-9px'
                                        }
                                    >
                                        <LabelCount colorNote={true}>
                                            {noteCount}
                                        </LabelCount>
                                    </CountContainer>
                                )}
                            </Icon>
                        </IconPlaceHolder>
                    ) : null}
                </>
            </IconsContainer>
        </>
    );
};

export default ReportUsageSubHeader;
